export default "__VITE_ASSET__Cz2LIQ4z__"